import React from 'react';
import PageTitle from '../../layouts/PageTitle';
import '../../../scss/pages/_requestchanges-list.scss'

const RequestChanges = () => {
    return (
        <div className='requestChanges'>
            <PageTitle
                title="Request Changes"
                subtitle="Request Changes"
            />
             
            <div className="row">
                <div className="col-md-5 col-lg-5">
                    <div className='card rounded-0 w-100 mt-5'>
                        <div className='card-body'>
                            <span className='fw-bold fs-5'>  Please click the button below if you need help with one of the topics below:</span>
                            <ul className='mt-2 ms-3'>
                                <li>Dish Images or Location </li>
                                <li className='mt-1'>Payments,Billing or Account Details </li>
                                <li className='mt-1'>Device, Software or Restaurant Portal Access </li>
                                <li className='mt-1'>Bringing my restaurant Online/Live or Adding an outlet </li>
                                <li className='mt-1'>Restaurant Operations, Rider Issues & Complaints</li>
                                <li className='mt-1'>Following up on a case</li>
                            </ul>
                            <button className='btn btn-sm btn-square btn-secondary mt-4'>REQUEST CHANGE</button>
                            <br />
                            <br />
                            <span>Clicking this button will open an external webpage</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
    );
};

export default RequestChanges;